const fscplacehoder = {
  inserted: function (el: HTMLElement) {
    const placeholderValue = (el as HTMLInputElement).placeholder;
    if (placeholderValue && !placeholderValue.endsWith("...")) {
      (el as HTMLInputElement).placeholder = placeholderValue + " ...";
    }
  },
};
export default fscplacehoder;
